module.exports = __webpack_public_path__ + "img/USPTO.ebd52108.jpg";